import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ClassroomActiveContainer from './active/ClassroomActiveContainer';
import { ROLE, TABS_CONSTANTS, TABS_CONSTANTS_TRANSLATIONS, TABS_CONTSTANTS_ICONS } from '../../../const';
import { isEmbbededInTeams } from '../../../services/crossPlatform/crossPlatformService';
import SwipeableTabsContainer from '../../common/SwipeableTabsContainer';
import AssignmentsContainer from '../../assignments/AssignmentsContainer';
import LibraryContainer from '../../library/LibraryContainer';
import NoHome from './NoHome';
import { filterTabsByUserConfig } from '../../../utils/tabsUtils';
import * as messageAlert from '../../../actions/messageAlertAction';
import { I18n } from 'react-redux-i18n-lite';

class Home extends React.Component {
  static propTypes = {
    role: PropTypes.string,
    username: PropTypes.string,
    layoutSettings: PropTypes.any,
    enableHomeView: PropTypes.bool,
    classroomTabs: PropTypes.array,
    tab: PropTypes.string
  };

  getUserSettings() {
    const { layoutSettings, role } = this.props;
    return role === ROLE.INSTRUCTOR
      ? layoutSettings.teacherSettings
      : role === ROLE.COINSTRUCTOR
      ? layoutSettings.coinstructorSettings
      : layoutSettings.studentSettings;
  }

  getClassroomActiveContainer() {
    return (
      <div key="classroom">
        <ClassroomActiveContainer animateHeight={true} cardWidth={310} cardHeight={310} />
      </div>
    );
  }

  renderSwipeableViews() {
    const tabs = filterTabsByUserConfig(this.props.classroomTabs);

    return tabs.map(tabConst => {
      switch (tabConst) {
        case TABS_CONSTANTS.MY_CLASSROOMS:
          return this.getClassroomActiveContainer();
        case TABS_CONSTANTS.ASSIGNMENTS:
          return <AssignmentsContainer key="homeAssignments" />;
        case TABS_CONSTANTS.CLASSROOM_LIBRARY:
          return <LibraryContainer key="homeLibrary" />;
        default:
          return this.getClassroomActiveContainer();
      }
    });
  }

  getTabsConstants() {
    if (!isEmbbededInTeams()) {
      const tabs = filterTabsByUserConfig(this.props.classroomTabs);

      const tabObject = {};
      tabs.forEach(tab => {
        tabObject[tab] = {
          label: TABS_CONSTANTS_TRANSLATIONS[tab],
          icon: TABS_CONTSTANTS_ICONS[tab],
          key: tab
        };
      });
      return tabObject;
    } else {
      return {
        [TABS_CONSTANTS.MY_CLASSROOMS]: {
          label: TABS_CONSTANTS_TRANSLATIONS[TABS_CONSTANTS.MY_CLASSROOMS],
          key: TABS_CONSTANTS.MY_CLASSROOMS
        }
      };
    }
  }

  getSelectedTabIndex() {
    const { tab } = this.props;
    return filterTabsByUserConfig(this.props.classroomTabs).indexOf(tab) || 0;
  }

  componentDidMount() {
    this.checkForAlertError();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.checkForAlertError();
    }
  }

  checkForAlertError() {
    const location = this.props.location || {};
    const state = location.state || {};
    if (state && state.alertError) {
      setTimeout(() => {
        this.props.dispatch(messageAlert.error(I18n.t(state.alertError)));
        if (this.props.location) {
          this.props.location.state = {};
        }
      }, 0);
    }
  }

  render() {
    const { enableHomeView, username } = this.props;
    return enableHomeView ? (
      <SwipeableTabsContainer
        wrapperClassName="home"
        tabsConstants={this.getTabsConstants()}
        selectedTabIndex={this.getSelectedTabIndex()}
        views={this.renderSwipeableViews()}
      />
    ) : (
      <NoHome username={username} />
    );
  }
}

function mapStateToProps(state) {
  return {
    role: state.account.user.role,
    username: state.account.user.name,
    layoutSettings: state.theme.layoutSettings,
    enableHomeView: state.account.configuration.enableHomeView,
    classroomTabs: state.account.configuration.classroomTabs
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
